<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' IP PROFILE'">

    <form #mapForm="ngForm" autocomplete="off">
        <div class="form-row">
            <mat-form-field class="fullWidth">
                <mat-label>Name</mat-label>
                <input matInput required [(ngModel)]="data.selectedItem.name" maxlength="40" name="name" [disabled]="data.isEditMode">
                <mat-error>
                    Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-row">
            <div class="form-column">
                <mat-form-field class="fullWidth">
                    <mat-label>SBC Media Security Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.sbcMediaSecurityMode" name="sbcMediaSecurityMode">
                        <mat-option *ngFor="let option of ipProfileOptions.sbcMediaSecurityMode" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote REFER Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.sbcRemoteReferBehavior" name="sbcRemoteReferBehavior">
                        <mat-option *ngFor="let option of ipProfileOptions.sbcRemoteReferBehavior"
                                    [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>ICE Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.iceMode" name="iceMode">
                        <mat-option *ngFor="let option of ipProfileOptions.iceMode" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote re-INVITE</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.remoteReInvite" name="remoteReInvite">
                        <mat-option *ngFor="let option of ipProfileOptions.remoteReInvite" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote Representation Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.representationMode" name="representationMode">
                        <mat-option *ngFor="let option of ipProfileOptions.representationMode" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-column">
                <mat-form-field class="fullWidth">
                    <mat-label>Remote 3xx Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.sbcRemote3xxBehavior" name="sbcRemote3xxBehavior">
                        <mat-option *ngFor="let option of ipProfileOptions.sbcRemote3xxBehavior" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote Replaces Mode</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.sbcRemoteReplacesBehavior"
                                name="sbcRemoteReplacesBehavior">
                        <mat-option *ngFor="let option of ipProfileOptions.sbcRemoteReplacesBehavior"
                                    [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>SIP UPDATE Support</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.sipUpdateSupport" name="sipUpdateSupport">
                        <mat-option *ngFor="let option of ipProfileOptions.sipUpdateSupport" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote Delayed Offer Support</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.remoteDelayedOfferSupport"
                                name="remoteDelayedOfferSupport">
                        <mat-option *ngFor="let option of ipProfileOptions.remoteDelayedOfferSupport"
                                    [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Remote Hold Format</mat-label>
                    <mat-select [(ngModel)]="data.selectedItem.remoteHoldFormat" name="remoteHoldFormat">
                        <mat-option *ngFor="let option of ipProfileOptions.remoteHoldFormat" [value]="option.value">
                            {{option.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
</arm-dialog>
